// dev-navbar-sticky — pins .dev-navbar (logo/search/cart/menu row) to the top
// of the viewport on mobile once .dev-topbar (the shipping/promo bar above
// it) has scrolled out of view.
//
// Deliberately NOT plain `position: sticky`: each Shopify section renders as
// an independent sibling <section>, so .dev-navbar's own wrapper is only ever
// as tall as .dev-navbar itself — sticky would have zero room to visually
// stay stuck before its own containing block also scrolls out of view. This
// uses the same position:fixed + IntersectionObserver + data-stuck pattern
// already proven by assets/sticky-add-to-cart.js elsewhere in this theme.

(function () {
  var navbar = document.querySelector('.dev-navbar');
  var topbar = document.querySelector('.dev-topbar');
  if (!navbar || !topbar) return;

  var mq = window.matchMedia('(max-width: 769px)');

  var spacer = document.createElement('div');
  spacer.className = 'dev-navbar__spacer';
  spacer.setAttribute('aria-hidden', 'true');
  navbar.after(spacer);

  function stick() {
    if (!mq.matches) return;
    spacer.style.height = navbar.getBoundingClientRect().height + 'px';
    navbar.setAttribute('data-stuck', 'true');
  }

  function unstick() {
    navbar.removeAttribute('data-stuck');
    spacer.style.height = '';
  }

  var observer = new IntersectionObserver(function (entries) {
    var entry = entries[0];
    if (!entry) return;
    if (entry.isIntersecting || !mq.matches) unstick();
    else stick();
  });
  observer.observe(topbar);

  // Resized across the breakpoint without a scroll/intersection change.
  mq.addEventListener('change', function () {
    if (!mq.matches) unstick();
  });
})();
